//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DivSpan from '@/components/DivSpan'
import fileUpload from '@/components/file-upload';
export default {
  components:{
    DivSpan,
    fileUpload
  },
  data(){
    return{
      cargoDto:{},
      cargoId:null
    }
  },
  methods:{
    getContractItemDto(){
      this.$get('api/requireGoodsOrder/' + this.cargoId).then((data) => {
        this.cargoDto = data;
        console.log(this.cargoDto)
      })
    }
  },
  mounted(){
    this.cargoId = this.$route.params.id;
    this.getContractItemDto();
  }
}



// WEBPACK FOOTER //
// ./src/page/cargo-plan/view/base-info.vue